module.exports = __webpack_public_path__ + "img/not-available-es.a33cd45a.png";